import React, { useState, useEffect } from "react";
import moment from "moment";

import "./basicProfile.css";
import {
  TextInputField,
  TextInput,
  Select,
  option,
  FilePicker,
} from "evergreen-ui";
import SaveBTN from "./SaveBtn/SaveBTN";
import Multiselect from "multiselect-react-dropdown";
import SubmitButton from "../../Buttons/SubmitButton/SubmitButton";

const BasicProfile = ({
  allData,
  setAllData,
  handleProfileUpdate,
  RenderingFunc,
}) => {
  const [productSelectedData, setproductSelectedData] = useState([]);

  const [switchEdit, setswitchEdit] = useState(false);
  const [getAllData, setgetAllData] = useState(allData);
  const [countryCode, setCountryCode] = useState("");
  const [productType, setProductType] = useState([]);
  const [category, setcategory] = useState();
  const handleBasicProfile = (e) => {
    const { name, value } = e.target;
    setAllData({
      ...allData,
      [name]: value,
    });
  };
  const saveHandler = () => {
    handleProfileUpdate();
    setswitchEdit(false);
  };
  const getAllCountry = () => {
    fetch(process.env.REACT_APP_API_URL + "/api/vendor/all_country", {
      method: "POST",
    })
      .then((d) => d.json())
      .then((res) => {
        setCountryCode(res.response);
      })
      .catch((err) => console.log("e", err));
  };
  const loadProductType = () => {
    fetch(process.env.REACT_APP_API_URL + "/api/vendor/allcategories", {
      method: "POST",
    })
      .then((d) => d.json())
      .then((res) => {
        let cate = res.response.filter((e) => {
          return e.category_id == allData.typeOfProduct;
        });
        setProductType(res.response);
      })
      .catch((err) => console.log("e", err));
  };

  const customMultiselectData = {
    multiselectContainer: {
      marginTop: "4px",
      marginBottom: "12px",
      background: "white",
      width: "279px",
    },
    searchBox: {
      Height: "32px",
      background: "white",
      width: "279px",
    },
    inputField: {
      background: "white",
      width: "240px",
      fontSize: "12px",
      fontWeight: "400",
    },
    chips: {
      background: "var(--BaseLightColor)",
      borderRadius: "4px",
      fontSize: "12px",
      color: "var(--TextLightColor)",
    },
    optionContainer: {
      border: "2px solid #ECEBEC",
      overflowY: "scroll",
      height: "100px",
      marginBottom: "10px",
    },
    option: {
      fontWeight: "400",
      fontSize: "12px",
      lineHeight: "0px",
    },
    groupHeading: {},
  };

  const OnSelectProduct = (selectedList, selectedItem) => {
    setproductSelectedData([...selectedList]);
    let ids = selectedList.map((a) => a.id);
    let str = ids.join(",");
    setAllData({ ...allData, ["vendor_category_id"]: str });
  };

  const OnRemoveProduct = (selectedList, removedItem) => {
    setproductSelectedData([...selectedList]);
    let ids = selectedList.map((a) => a.id);
    let str = ids.join(",");
    setAllData({ ...allData, ["vendor_category_id"]: str });
  };

  const CommunityDelete = (val) => {
    const filterData = productSelectedData.filter((e) => e.id != val);
    setproductSelectedData(filterData);
  };

  useEffect(() => {
    getAllCountry();
    loadProductType();
  }, []);

  useEffect(() => {
    setproductSelectedData(allData.vendor_category_selected);
  }, [allData.vendor_category_selected]);

  return (
    <div className="basicProfileMainContainer">
      <div className="basicProfileFirtRow">
        <div className="basicProfileMainContainerHead">
          <div>
            <img src="./images/stratum/basicDetails.svg" alt="" />
          </div>
          <div className="basicdetailName">Basic Details</div>
        </div>
        {!switchEdit ? (
          <div
            className="editInPf"
            onClick={() => {
              setswitchEdit(true);
            }}
          >
            <img src="./images/stratum/edit.svg" alt="" />
          </div>
        ) : (
          <div
            className="editInPf"
            onClick={() => {
              setswitchEdit(false);
            }}
          >
            <img src="./images/stratum/closeLogo.svg" alt="" />
          </div>
        )}
      </div>
      <div className="detailsColumInProfile">
        <div>
          <p className="subHeadProfileTab"> Vendor Name</p>
          {!switchEdit ? (
            <div className="inputDesabledDta">
              {allData.vendor_name ? allData.vendor_name : "NA"}
            </div>
          ) : (
            <TextInput
              disabled
              className="pfInputManage"
              width={279}
              height={32}
              placeholder="Enter vendor Name"
              name="vendor_name"
              value={allData.vendor_name}
              onChange={handleBasicProfile}
              required
            />
          )}

          <p className="subHeadProfileTab">License Issue Date</p>
          {!switchEdit ? (
            <div className="inputDesabledDta">
              {allData.licenseIssueDate
                ? moment(allData.licenseIssueDate).format("DD MMM YYYY")
                : "NA"}
            </div>
          ) : (
            <div id="dateinPf">
              <input
                className="pfInputManage"
                type="date"
                placeholder="Select Date"
                name="licenseIssueDate"
                value={allData.licenseIssueDate}
                onChange={handleBasicProfile}
                required
              />
            </div>
          )}
          <p className="subHeadProfileTab"> Type of Product/Service</p>
          {!switchEdit ? (
            <div className="inputDesabledDta productClass">
              {allData.typeOfProduct &&
                allData.typeOfProduct.map((e, i) => {
                  return (
                    <span className="productSpanBasic">
                      {e.category_name}
                      {allData.typeOfProduct.length - 1 == i ? "" : ","}
                    </span>
                  );
                })}
            </div>
          ) : (
            productType.length > 0 && (
              <Multiselect
                width={200}
                height={32}
                options={productType}
                selectedValues={productSelectedData} // Preselected value to persist in dropdown
                onSelect={OnSelectProduct}
                onRemove={OnRemoveProduct}
                displayValue="name"
                closeIcon={"close"}
                style={customMultiselectData}
              />
            )
          )}
        </div>
        <div>
          <p className="subHeadProfileTab"> Trade License Number</p>
          {!switchEdit ? (
            <div className="inputDesabledDta">
              {allData.tradeLicenseNumber ? allData.tradeLicenseNumber : "NA"}
            </div>
          ) : (
            <TextInput
              disabled
              className="pfInputManage"
              width={279}
              height={32}
              placeholder="Enter Trade License Number"
              name="tradeLicenseNumber"
              value={allData.tradeLicenseNumber}
              onChange={handleBasicProfile}
              required
            />
          )}
          <p className="subHeadProfileTab">License Expiry Date</p>
          {!switchEdit ? (
            <div className="inputDesabledDta">
              {allData.licenseExpiryDate
                ? moment(allData.licenseExpiryDate).format("DD MMM YYYY")
                : "NA"}
            </div>
          ) : (
            <div id="dateinPf">
              <input
                className="pfInputManage"
                type="date"
                placeholder="Select Date"
                name="licenseExpiryDate"
                value={allData.licenseExpiryDate}
                onChange={handleBasicProfile}
                required
              />
            </div>
          )}
        </div>
        <div>
          <p className="subHeadProfileTab"> Tax Registration Number</p>
          {!switchEdit ? (
            <div className="inputDesabledDta">
              {allData.taxRegistrationNumber
                ? allData.taxRegistrationNumber
                : "NA"}
            </div>
          ) : (
            <TextInput
              className="pfInputManage"
              width={279}
              height={32}
              placeholder="Enter Tax Registration Number"
              name="taxRegistrationNumber"
              value={allData.taxRegistrationNumber}
              onChange={handleBasicProfile}
            />
          )}
          <p className="subHeadProfileTab"> Country</p>
          {!switchEdit ? (
            <div className="inputDesabledDta">
              {allData.countryName ? allData.countryName : "NA"}
            </div>
          ) : (
            <select
              id="countryInputSelectProfile"
              width={300}
              height={40}
              placeholder="Select"
              name="country"
              onChange={handleBasicProfile}
            >
              {countryCode &&
                countryCode.map((e) =>
                  e.country_name == allData.countryName ? (
                    <option value={e.country_id} selected>
                      {e.country_name}
                    </option>
                  ) : (
                    <option value={e.country_id}>{e.country_name}</option>
                  )
                )}
            </select>
          )}
        </div>
      </div>
      {switchEdit && (
        <div className="btnmarginPf">
          {/* <SaveBTN handlesave={saveHandler} /> */}
          <SubmitButton ApplyFunction={saveHandler} text={"Save Changes"} />
        </div>
      )}
    </div>
  );
};

export default BasicProfile;
